// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"d085792e","246":"e6632e5e","481":"4058b226","743":"53872fa1","745":"d1dbdd94","825":"53872fa1","850":"d1dbdd94"}[chunkId] + ".chunk.css";
};